export enum ChartTypes {
    unknown = "unknown",
    gonio = "gonio"
}
